import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Link, Outlet } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'
import { RouteError } from '@/components/ui/RouteError'

/** Available to every route via `beforeLoad`/`loader` — see `src/router.tsx`. */
export interface RouterContext {
  queryClient: QueryClient
}

// Devtools are dev-only and must never land in the production bundle.
const Devtools = import.meta.env.PROD
  ? () => null
  : lazy(async () => {
      const [router, query] = await Promise.all([
        import('@tanstack/react-router-devtools'),
        import('@tanstack/react-query-devtools'),
      ])
      return {
        default: () => (
          <>
            <router.TanStackRouterDevtools position="bottom-right" />
            <query.ReactQueryDevtools initialIsOpen={false} />
          </>
        ),
      }
    })

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  notFoundComponent: NotFound,
  errorComponent: RouteError,
})

function RootLayout() {
  return (
    <div className="app-shell">
      <Outlet />
      <Suspense fallback={null}>
        <Devtools />
      </Suspense>
    </div>
  )
}

function NotFound() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-3 p-6 text-center">
      <h1 className="text-lg font-semibold">Halaman tidak ditemukan</h1>
      <Link to="/" className="text-brand-600 text-sm font-medium underline">
        Kembali ke aplikasi
      </Link>
    </div>
  )
}
